import { Slide } from '@/components/core/Slide';
import { WebContent } from '@/components/web/WebContent';

export const slide = () => {
  return (
    <Slide
      notes="Overview of the main topics we'll cover today"
      transition="fade"
      networkBackground="full"
    >
      <div className="relative z-10 flex flex-col items-center justify-center h-full">
        <WebContent
          animation={{
            type: 'fade',
            delay: 0,
            duration: 800,
          }}
        >
          <h2 className="text-4xl font-light mb-8">Waar gaan we het over hebben?</h2>
        </WebContent>

        <div className="space-y-4">
          <WebContent
            animation={{
              type: 'fade',
              delay: 1000,
              duration: 800,
            }}
          >
            <p className="text-2xl font-light">• De toekomst van werk in de techniek</p>
          </WebContent>

          <WebContent
            animation={{
              type: 'fade',
              delay: 2000,
              duration: 800,
            }}
          >
            <p className="text-2xl font-light">• AI-readiness voor bedrijven</p>
          </WebContent>

          <WebContent
            animation={{
              type: 'fade',
              delay: 3000,
              duration: 800,
            }}
          >
            <p className="text-2xl font-light">• Praktische AI-tools</p>
          </WebContent>
        </div>
      </div>
    </Slide>
  );
};
